import { z } from 'zod';

/**
 * Password regex pattern: at least 8 characters, must contain:
 * - One lowercase letter
 * - One uppercase letter
 * - One digit
 * - One special character
 */
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

/**
 * Login form validation schema using Zod
 */
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Invalid email address')
    .max(100, 'Email must not exceed 100 characters')
    .trim(),
  password: z
    .string()
    .min(1, 'Password is required')
    .min(8, 'Password must be at least 8 characters')
    .max(255, 'Password must not exceed 255 characters')
    .regex(
      PASSWORD_REGEX,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
    ),
});

/**
 * Infer TypeScript type from schema
 */
export type LoginFormData = z.infer<typeof loginSchema>;
